import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'atoms';

export default function IconLabel({ label }) {
	return (
		<Flex justifyContent="center" alignItems="center">
			<Text as="span" pl="5px" fontSize="16px" fontWeight="bold" color="#2a2a2a" pb="0.5rem">
				{label}
			</Text>
		</Flex>
	);
}

IconLabel.propTypes = {
	label: PropTypes.string.isRequired,
};
